/* __next_internal_client_entry_do_not_use__ Insider auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "./util";
var InsiderIcon = createSVGIcon(/*#__PURE__*/ _jsx(_Fragment, {
    children: /*#__PURE__*/ _jsx("path", {
        d: "M20.0166 14.3695H25M12.7737 10.7507H25M12.8235 11.5C12.8235 14.5376 10.4006 17 7.41177 17C4.42293 17 2 14.5376 2 11.5C2 8.46243 4.42293 6 7.41177 6C10.4006 6 12.8235 8.46243 12.8235 11.5Z",
        stroke: "currentColor",
        strokeWidth: "2.5"
    })
}), "Insider", {
    viewBox: "0 0 24 24",
    titleAccess: "Insider",
    fill: "none",
    width: "24",
    height: "auto",
    color: Decorative.icon.teal
});
var SmallInsiderIcon = createSVGIcon(/*#__PURE__*/ _jsx(_Fragment, {
    children: /*#__PURE__*/ _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.87398 8C8.42994 9.72523 6.86384 11 5 11C2.79086 11 1 9.20914 1 7C1 4.79086 2.79086 3 5 3C6.86384 3 8.42994 4.27477 8.87398 6L15 6V7V8V9.75H12V8L8.87398 8ZM5 9.22222C6.2273 9.22222 7.22222 8.2273 7.22222 7C7.22222 5.7727 6.2273 4.77778 5 4.77778C3.7727 4.77778 2.77778 5.7727 2.77778 7C2.77778 8.2273 3.7727 9.22222 5 9.22222Z",
        fill: "currentColor"
    })
}), "Insider", {
    viewBox: "0 0 16 16",
    titleAccess: "Insider",
    width: "16",
    height: "auto",
    color: Decorative.icon.teal
});
/**
 * @trackcomponent
 */ export var Insider = /*#__PURE__*/ React.memo(/*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var small = _param.small, props = _object_without_properties(_param, [
        "small"
    ]);
    return small ? /*#__PURE__*/ _jsx(SmallInsiderIcon, _object_spread({
        ref: ref
    }, props)) : /*#__PURE__*/ _jsx(InsiderIcon, _object_spread({
        ref: ref
    }, props));
}));
